import { autoinject } from 'aurelia-framework';
import { NetlogHttpClient } from 'lib/http';
import { QueryFilter } from 'lib/tables/DataFilter';
import { CreatePenOfferDto, CreatePenOfferResponseDto, PenOfferDto, PenOfferListItemDto } from 'models/pen/PenOffers';
import { PenOfferStatusDto } from 'models/pen/PenOfferStatus';
import { saveAs } from 'file-saver';
import { DateFormatValueConverter } from 'value-converters/date-format';

@autoinject
export class PenOfferService {
  constructor(private client: NetlogHttpClient) {}

  async getOffer(id: number) {
    return await this.client.get<PenOfferDto>({
      url: `api/pen-offers/get-offer/${id}`,
      model: PenOfferDto,
    });
  }

  async createOffer(data: CreatePenOfferDto) {
    return await this.client.post({
      data,
      url: 'api/pen-offers/create-offer',
      model: CreatePenOfferResponseDto,
    });
  }

  async updateOffer(id: number, data: PenOfferDto) {
    return await this.client.patch({
      data,
      url: `api/pen-offers/update/${id}`,
    });
  }

  async getOffers(query: QueryFilter) {
    return await this.client.get<PenOfferListItemDto[]>({
      url: `api/pen-offers/list${query.asQueryString}`,
      model: PenOfferListItemDto,
    });
  }

  async getOffersExport(query: QueryFilter) {
    const f = await this.client.execNoTransform(`api/pen-offers/list/export${query.asQueryString}`, {
      method: 'GET',
    });
    return f.blob().then((blob) => {
      const dateString = new DateFormatValueConverter().toView(new Date(), 'DD-MM-YYYY');
      saveAs(blob, `pen-offers-${dateString}.xlsx`);
    });
  }

  async updateOfferStatus(id: number, data: PenOfferStatusDto) {
    return await this.client.patch({
      data,
      url: `api/pen-offers/${id}/status`,
    });
  }
}
